export const state = {
  currentIds: {
    facebook: [],
    googleAnalytics: [],
    googleAdwords: [],
    tiktok: [],
    lastPinterest: null,
    lastTwitter: null,
  },
  campaign: null,
  product: null,
  cart: null,
  quantity: null,
  size: null,
  coupon: null,
  merchant: null,
  order: null,
  upsell: null,
};

export const mutations = {
  trackId(state, { property, value }) {
    if (property === 'lastPinterest' || property === 'lastTwitter') {
      state.currentIds[property] = value;
    } else {
      state.currentIds[property].push(value);
    }
  }
};